module.exports = __webpack_public_path__ + "img/05.5bdd54e7.png";